import { FormikInputView } from './formik-input-view';

export const FormikPasswordView = ({ name, label, type = 'password', className, formik, ...other }) => (
  <FormikInputView label={label} className={className} name={name} type={type} formik={formik} {...other} />
);
